import type { ReactElement } from 'react';
import { useEffect } from 'react';

type NavigationWithSetOptions = {
  setOptions: (options: { header: () => ReactElement }) => void;
};

/**
 * Sets a screen's header from a JSX element.
 *
 * React Navigation headers are applied imperatively (`setOptions`) and expect a
 * render function; this hook hides both concerns so callers just pass the header
 * element. Memoize the element (`useMemo`) so `setOptions` only runs when the
 * header actually changes.
 */
export const useNavigationHeader = (
  navigation: NavigationWithSetOptions,
  header: ReactElement
) => {
  useEffect(() => {
    navigation.setOptions({ header: () => header });
  }, [navigation, header]);
};
